import {useReducer} from "react";
import reducer, {ActionType, LOCAL_STORAGE_KEY} from "./reducer";
import initialState from "./state"

const UseMapData = () => {

    const [state, dispatch] = useReducer(reducer, localStorage.getItem(LOCAL_STORAGE_KEY) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) : initialState)

    const setStyle = value => dispatch({type: ActionType.SetStyle, value})
    const setLayers = value => dispatch({type: ActionType.SetLayers, value})
    const addLayer = value => dispatch({type: ActionType.AddLayer, value})
    const toggleLayer = value => dispatch({type: ActionType.ToggleLayer, value})
    const setCenter = value => dispatch({type: ActionType.SetCenter, value})

    return {
        state,
        setStyle,
        setLayers,
        addLayer,
        toggleLayer,
        setCenter,
    }

}

export default UseMapData
